import React__default from 'react';

const QuantityItem = ({ className , label , subtext , aside  })=>/*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement("div", {
        className: `${className}__quantity`
    }, /*#__PURE__*/ React__default.createElement("span", {
        className: `${className}__amount`
    }, label), subtext && /*#__PURE__*/ React__default.createElement("span", {
        className: `${className}__subtext`
    }, subtext)), aside && /*#__PURE__*/ React__default.createElement("span", {
        className: `${className}__aside`
    }, aside))
;

export { QuantityItem };
//# sourceMappingURL=QuantityItem.js.map
